import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import download from "../../../helpers/download";
import { getRptDispositivos } from "./services";

const initialState = {
  status: "",
  noContent: true
};

export const actionGetRpTDispositivos = createAsyncThunk<any, string>(
  "ACTION_GET_RPTPTOS_DISPOSITIVOS",
  async (reportType, { getState }: any) => {
    const {
      getLojas: { lojaSelected, lojaSelectedInfos: {nome} },
    } = getState();

    const result = await getRptDispositivos({
      idLoja: lojaSelected,
      reportType,
    });

    download(result, {ext: reportType, fileName: `relatorio-${nome}`});

    return result;
  }
);

const sliceGetRptDispositivos = createSlice({
  name: "GET_RPTPTOSPANORAMA",
  initialState,
  reducers: {},
  extraReducers: {
    [`${actionGetRpTDispositivos.pending}`]: (state) => {
      state.status = "loading";
    },
    [`${actionGetRpTDispositivos.fulfilled}`]: (state, { payload: { status } }) => {
      state.status = "success";
      state.noContent = status === 204
    },
    [`${actionGetRpTDispositivos.rejected}`]: (state) => {
      state.status = "error";
    },
  },
});

export default sliceGetRptDispositivos.reducer;
